import { createAction } from "@reduxjs/toolkit";
import { TalesArea } from "../../../utils/types/TalesArea";

export const setAreeData = createAction<TalesArea[] | null>("aree/setData");
